import { TFunction } from '@mint-lib/i18n';

import { GOAL_GROUPS } from '../pages/Builder/BuilderBody/BuilderTable/ColumnFields/GoalField/types.js';
import {
  CustomColumnFormat,
  CustomColumnType,
} from '../types/builderTableView.js';

export const DECIMAL_LIMIT = {
  INTEGER: 0,
  PERCENT: 2,
  BUDGET: 2,
  PREDICTIVE_BUDGET: 5,
  PRICE_VALUE: 3,
};

export enum BUILDER_ROW_TYPES {
  CHANNEL = 'channel',
  PLATFORM = 'platform',
  MEDIA_NETWORK = 'media_ad_network',
  TILE = 'campaign',
  TOTAL = 'total',
  VERSION = 'version',
}
export enum BUILDER_ROW_DEPTH {
  CHANNEL = 0,
  PLATFORM = 1,
  MEDIA_ROW = 2,
}

export enum VERSION_TABLE_ROW_DEPTH {
  VERSION = 0,
  CHANNEL = 1,
  PLATFORM = 2,
}

export enum EST_GOALS_TYPE {
  COST = 'cost',
  QUANTITY = 'quantity',
  PERCENT = 'percent',
}

export const DEFAULT_FIELD_WIDTH = 208;
export const CONTENT = 'fit-content';

export const DRAG_ROW_TYPE = 'row';
export const APPROVAL_FLOW_TYPE = 'buying_plan';

export enum HISTORICAL_DATA_STATUSES {
  AVAILABLE = 1,
  UNAVAILABLE = 0,
}

export enum ROW_STATUSES {
  ALL = 'All rows',
  PLANNED = 'Mapped rows',
  UNPLANNED = 'Unmapped rows',
}

export const planningAccess = {
  TOTAL: 'full_control',
  VIEW: 'view',
};

export const ROW_HEIGHT = 40;
export const EMPTY_VALUE = '-';
export const MIN_COLUMN_WIDTH = 50;

export const getMapTypeValueToName = (
  t: TFunction,
): Record<CustomColumnType, string> => ({
  [CustomColumnType.singleInput]: t('Single input'),
  [CustomColumnType.select]: t('Select'),
});

export const getMapFormatValueToName = (
  t: TFunction,
): Record<CustomColumnFormat, string> => ({
  [CustomColumnFormat.text]: t('Text'),
  [CustomColumnFormat.number]: t('Number'),
  [CustomColumnFormat.integer]: t('Integer'),
  [CustomColumnFormat.currency]: t('Currency'),
  [CustomColumnFormat.percentage]: t('Percentage'),
});

export const goalGroups = [
  { id: GOAL_GROUPS.ADSERVER_GOALS, label: 'Adserver', path: 'adServer' },
  { id: GOAL_GROUPS.ANALYTICS_GOALS, label: 'Analytics', path: 'analytics' },
  {
    id: GOAL_GROUPS.CUSTOM_METRICS,
    label: 'Custom metrics',
    path: 'dataImportHub',
  },
];

export const getTranslatedGoalGroups = (t: TFunction) =>
  goalGroups.map((group) => ({
    ...group,
    label: t(group.label),
  }));

export enum PREDICTIVE_ERROR {
  INFEASIBLE = 'Infeasible',
}
